import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

const Pagination = props => {
  const {
    baseRoute,
    isFirstPage,
    isLastPage,
    previousRoute,
    nextRoute,
    previousText,
    nextText,
  } = props;

  const previousPageUrl = previousRoute ? `${baseRoute}/${previousRoute}` : baseRoute;
  const nextPageUrl = nextRoute ? `${baseRoute}/${nextRoute}` : baseRoute;

  return (
    <nav className="pagination is-centered" aria-label="pagination">
      {isFirstPage ? (
        <span className="pagination-previous" disabled>
          &larr; {previousText}
        </span>
      ) : (
        <Link to={previousPageUrl} className="pagination-previous">
          &larr; {previousText}
        </Link>
      )}
      {isLastPage ? (
        <span className="pagination-next" disabled>
          {nextText} &rarr;
        </span>
      ) : (
        <Link to={nextPageUrl} className="pagination-next">
          {nextText} &rarr;
        </Link>
      )}
    </nav>
  );
};

Pagination.propTypes = {
  baseRoute: PropTypes.string,
  isFirstPage: PropTypes.bool,
  isLastPage: PropTypes.bool,
  previousRoute: PropTypes.string,
  nextRoute: PropTypes.string,
  previousText: PropTypes.string,
  nextText: PropTypes.string,
};

Pagination.defaultProps = {
  baseRoute: '/',
  isFirstPage: true,
  isLastPage: true,
  previousRoute: '',
  nextRoute: '',
  previousText: 'Previous Page',
  nextText: 'Next Page',
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Pagination.js